module.exports = __webpack_public_path__ + "static/media/MUCHB.56599376.svg";